import { memo, useCallback, useEffect } from 'react';
import { Layout, theme } from 'antd';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { themeStyle } from '../../../app/theme/themeSlice';
import { Nav, SearchNav } from '../../ui';
import './styles.scss';
import {
  commonState,
  setShowNav,
  setShowSearchNav,
} from '../../../app/base/commonSlice';
import useShortcut from '../../../utils/hooks/useShortcut';

const { Header } = Layout;

function Topbar() {
  const { profileSearch, setSearchType } = useShortcut();
  const myBracTheme = useSelector(themeStyle);
  const { showSearchNav, showNav } = useSelector(commonState);
  const dispatch = useDispatch();
  const mode = myBracTheme.mode === 'light';

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const handleSearchButtonClick = useCallback(() => {
    dispatch(setShowSearchNav(true));
    dispatch(setShowNav(false));
    setSearchType('my-brac');
  }, [dispatch, setSearchType]);

  const handleCloseButtonClick = useCallback(() => {
    dispatch(setShowSearchNav(false));
    dispatch(setShowNav(true));
    setSearchType('');
  }, [dispatch, setSearchType]);

  useEffect(() => {
    dispatch(setShowSearchNav(false));
    dispatch(setShowNav(true));
  }, [dispatch]);

  return (
    <Header
      className={classNames('headerStyle', {
        headerStyleMobile: isMobile,
      })}
      style={{
        background: mode ? colorBgContainer : '#1D1D1D',
        borderBottom: mode ? '' : '1px solid #565657',
      }}
    >
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0 }}
          className={`nav-transition h-full w-full ${
            showNav ? 'fade-in block' : 'fade-out hidden'
          }`}
        >
          <Nav onSearchButtonClick={handleSearchButtonClick} />
        </motion.div>
        {showSearchNav && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.5 } }}
            exit={{ opacity: 0 }}
            className={`search-nav-transition ${
              showSearchNav ? 'fade-in block' : 'fade-out hidden'
            }`}
          >
            <SearchNav
              profileSearch={profileSearch}
              onCloseButtonClick={handleCloseButtonClick}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </Header>
  );
}

export default memo(Topbar);
